import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param dirty - The HTML string to sanitize
 * @returns The sanitized HTML string
 */
export const sanitizeHTML = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'sup', 'sub', 
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote',
      'a', 'img', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'div', 'span'
    ],
    ALLOWED_ATTR: [
      'href', 'title', 'src', 'alt', 'width', 'height',
      'class', 'id', 'style'
    ],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:)/i
  });
};

/**
 * Creates a safe HTML props object for React components
 * @param htmlContent - The HTML content to sanitize
 * @returns Object with __html property containing sanitized content
 */
export const createSafeHTML = (htmlContent: string) => ({
  __html: sanitizeHTML(htmlContent)
});

/**
 * Sanitizes HTML for email templates with more permissive settings
 * @param dirty - The HTML string to sanitize
 * @returns The sanitized HTML string
 */
export const sanitizeEmailHTML = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'sup', 'sub', 
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote',
      'a', 'img', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'div', 'span', 'font', 'center'
    ],
    ALLOWED_ATTR: [
      'href', 'title', 'src', 'alt', 'width', 'height',
      'class', 'id', 'style', 'color', 'face', 'size',
      'align', 'valign', 'bgcolor', 'border', 'cellpadding', 'cellspacing'
    ],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#)/i
  });
};